// MARK:- <as-autoplay-video> recovers when the OS/browser blocks muted autoplay
// (iOS Low Power Mode, "Auto-Play Video Previews" off, Safari per-site Never Auto-Play,
// Low Data Mode). On rejection: retries once on first user pointerdown anywhere on the
// page, AND exposes native controls so the user can play it manually either way.
class AsAutoplayVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    this.abort = new AbortController();

    const playPromise = video.play();
    if (!playPromise || typeof playPromise.catch !== 'function') return;

    playPromise.catch(() => {
      video.setAttribute('controls', '');
      document.addEventListener(
        'pointerdown',
        () => { video.play().catch(() => {}); },
        { once: true, passive: true, signal: this.abort.signal }
      );
    });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }
}

customElements.define('as-autoplay-video', AsAutoplayVideo);
